import { render, staticRenderFns } from "./TemplatesList.vue?vue&type=template&id=1f8b0093&scoped=true&"
import script from "./TemplatesList.vue?vue&type=script&lang=js&"
export * from "./TemplatesList.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesList.vue?vue&type=style&index=0&id=1f8b0093&lang=scss&scoped=true&"
import style1 from "./TemplatesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b0093",
  null
  
)

export default component.exports